import { useEffect, useMemo, useRef } from "react";
import { InputMain } from "./InputMain";
import { InputTitle } from "./InputTitle";
import { InputAction } from "./InputAction";
import { InputDelete } from "./InputAction/InputDelete";
import { InputEnter } from "./InputAction/InputEnter";
import { useAiSaasInputContainer } from "./container";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import css from "./index.module.scss";
import isBlank from "@sedan-utils/is-blank";
import { InputLoading } from "./InputAction/InputLoading";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { useAISaasPreviewItem } from "../hooks/useAISaasPreviewItem";
import { ReactFlowNodeUtil } from "@uikit/util/ReactFlowNodeUtil";

function InputInner(props: AISaas.AISaasInputItemInnerProps) {
  const inputRef = useRef(null);
  const { x, index } = props;
  const { id: itemId } = x.data;
  const {
    aiSaasProps,
    isFocus,
    isDarkMode,
    editPlaceholderData,
    setEditPlaceholder,
    isEditPlaceholder,
    onMouseLeaveBox,
    onMouseOverBox,
    onInputFocus,
    onDeleteInput,
    setSelectTips,
    selectTips,
  } = useAiSaasInputContainer();

  const featureTags = useFeatureTags();

  const AssetsPath = `${settings.S3CDN}${settings.viewAssetsPath}`;

  const showPreviewTittle = !isBlank(x?.data?.inputTitle) || !isBlank(x?.data?.generatedLabel) || !aiSaasProps.isShare;

  const { onPreviewItemMouseEnter, onPreviewItemMouseLeave } = useAISaasPreviewItem();

  const isUploadFileInputNode = useMemo(() => {
    return featureTags.disableUploadTypesAsInputNode === false && ReactFlowNodeUtil.isUploadNode(x.data);
  }, [featureTags.disableUploadTypesAsInputNode, x]);

  /* const isEditPlaceholder = useMemo(() => {
    return !isBlank(editPlaceholderData.value) && editPlaceholderData.value.id === itemId;
  }, [editPlaceholderData, itemId]); */
  useEffect(() => {
    // 当监听到selectTips变化了，那么需要刷新提示框的tips
    if (selectTips.value.id === x.id && selectTips.value.type === "inputField") {
      onPreviewItemMouseEnter(getMouceEnterParams());
    }
  }, [selectTips.value]);
  const getMouceEnterParams = () => {
    return isUploadFileInputNode
      ? {
          type: "fileUpload",
          id: x.id,
          container: inputRef.current,
          remove: () => onDeleteInput(null, itemId),
        }
      : {
          type: "inputField",
          id: x.id,
          container: inputRef.current,
          edit: (tips: string) => {
            setSelectTips(itemId, tips);
            onInputFocus(itemId, index);
          },
          remove: () => onDeleteInput(null, itemId),
          editPlaceholder: (tips: string) => setEditPlaceholder(itemId, true, tips),
          selectTips: selectTips.value,
        };
  };
  const mouseEnterParams = getMouceEnterParams();
  const isEditPlaceholderVlue = isEditPlaceholder.id === itemId ? isEditPlaceholder.isEdit : false;
  return (
    <div
      className={css["transparent-storey"]}
      onMouseLeave={onMouseLeaveBox}
      onMouseOver={() => onMouseOverBox(itemId)}
    >
      <div
        ref={inputRef}
        onMouseEnter={() => {
          onPreviewItemMouseEnter(mouseEnterParams);
        }}
        onMouseLeave={onPreviewItemMouseLeave}
        className={`${css["input-box"]} ${isFocus.value[itemId] ? css["enlarge-input-box"] : ""}
        ${isEditPlaceholderVlue ? css["convention-padding"] : ""}
        ${isDarkMode ? "dark" : ""} ${isUploadFileInputNode ? css["upload-file-box"] : ""}`}
      >
        {/* <InputAction x={x} /> */}
        <InputMain
          x={x}
          index={index}
          isEditPlaceholder={isEditPlaceholderVlue}
          isUploadFileInputNode={isUploadFileInputNode}
        />
        <InputEnter x={x} />
        <InputDelete x={x} isEditPlaceholder={isEditPlaceholderVlue} />
        <InputLoading />
      </div>
    </div>
  );
}

export function AISaasInputItem(props: AISaas.AISaasInputItemProps) {
  const { x, index } = props;
  const itemId = x.data.id;

  return (
    <div key={itemId}>
      <InputTitle x={x.data} />
      <InputInner x={x} index={index} />
    </div>
  );
}
